export const BOUND_REFERENCES = 'BOUND_REFERENCES';
export const RESOLVED = 'RESOLVED';
